export const booleanAttributeTrue = '1';
export const booleanAttributeFalse = '0';
export const booleanAttributeUnknown = undefined; // eslint-disable-line no-undefined
